import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        app: {},
        apps: [],
        sidebar: {},
        settings: {}
    },
    getters: {
        app(state) {
            return state.app;
        },
        apps(state) {
            return state.apps;
        },
        sidebar(state) {
            return state.sidebar;
        },
        settings(state) {
            return state.settings;
        }
    },
    actions: {
        async fetch(context) {
            return httpClient.get("/api/guest/app").then(data => {
                context.commit("SET_APP", data);
                return data;
            });
        },
        // to be moved to own store
        async fetchSidebar(context) {
            return httpClient.get("/api/guest/sidebar").then(data => {
                context.commit("SET_SIDEBAR", data);
                return data;
            });
        },
        // to be moved to own store
        async fetchSettings(context) {
            return httpClient.get("/api/guest/settings").then(data => {
                context.commit("SET_SETTINGS", data);
                return data;
            });
        }
    },
    mutations: {
        SET_APP(state, data) {
            state.app = data;
        },
        SET_APPS(state, data) {
            state.apps = data;
        },
        SET_SIDEBAR(state, data) {
            state.sidebar = data;
        },
        SET_SETTINGS(state, data) {
            state.settings = data;
            window.document.title = "";
        }
    }
};
